<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
        ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px;height:auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Response Of Quotation</b-navbar-brand>

          <b-navbar-nav class="ml-auto" center>
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">Response Of Quotation Order</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <!-- Search Form Input Start-->
            <div class="mt-3">
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Response Of Quotation" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
            </div>
            <!-- Search Form Input End-->
            <div class="mt-3">
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="stockList" responsive :fields="Columns"
                  primary-key="id_response_of_quotation" :per-page="perPage" :current-page="currentPage"
                  :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  class="position-relative">
                  <template slot="id_response_of_quotation" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="item_name" slot-scope="row9">
                    <span @click="viewAddRQPage(row9.item.id_response_of_quotation)">
                      {{
                      row9.item.item_name !=
                      "" ? row9.item.item_name : "--"
                      }}
                    </span>
                    <br />
                    <span>Created Date : {{ row9.item.created_at | moment }}</span><br />
                  </template>
                  <template slot="document_pdf" slot-scope="row1">
                    <b-button v-if="row1.item.document_pdf != null" @click="PrintNote(row1.item.document_pdf)" size="sm"
                      variant="outline-success">PDF</b-button>
                    <span v-else>N/A</span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>
  
  <script>
    import DatePicker from "vue2-datepicker";
    import axios from "axios";
    import moment from "moment";
    import { ModelListSelect, MultiSelect } from "vue-search-select";
  // import Loading from "vue-loading-overlay";
  import CustomLoader from "../../common/customLoader.vue";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
    import { DateFormat, selectDateFormat} from "../../../helper/filters.js";
    import { globalPermissionStatus } from "../../../helper/collection.js";
    import DateRangePicker from "vue2-daterange-picker";
    import MaintenanceService from "../../../services/MaintenanceService.js"

    export default {
        beforeMount() {
            if (globalPermissionStatus("Maintanence")) {
                this.$store.dispatch("setCurrentRoute", "/responseOfQuo/responseOfQuo");
                this.All_Response_Quotation_List_data();
            } else {
                this.$router.push({
                    path: "/dashboard"
                });
            }
        },
        data() {
          return {
              ExcelBtnName: "Export As Excel",
              addEditCard: false,
              isLoading: false,
              showCal: false,
              selectDateFormat,
              openLeft: "left",
              StatusList: [
                {
                  inv: "2",
                  int: "All",
                },
                {
                  inv: "0",
                  int: "Inactive",
                },
                {
                  inv: "1",
                  int: "Active",
                }
              ],
              Columns: [
                {
                    key: "id_response_of_quotation",
                    label: "SN",
                    sortable: true,
                    sortDirection: "desc",
                },
                {
                    key: "item_name",
                    label: "Item Details",
                    sortable: true,
                    sortDirection: "desc",
                },
                {
                  key: "document_pdf",
                  label: "Document",
                  sortable: true,
                  sortDirection: "desc",
                }
              ],
              Status: "1",
              docURL: URL_BASE_DOC,
              currentPage: 1,
              perPage: 10,
              totalRows: "",
              sortBy: null,
              sortDesc: false,
              pageOptions: [5, 10, 15],
              adminToggle: this.$sessionsStorage.get(),
              sortDirection: "desc",
              filter: null,
              changePageFilter: "0",
              modalInfo: { title: "", content: "" },
              alert: {
              content: "Added Succesfully",
              ok: "ok",
              },
              stockList: [],
              All_Pridel_Document_data: [],
              All_Document_TypeList: [],
              validate: true,
              visible: false,
              dateRange: {
                startDate: "",
                endDate: "",
              },
              dateSearch: {
                fromDate: "",
                toDate: "",
              },
              startDate: "2017-09-05",
              endDate: "2017-09-15",
          };
        },
        filters: {
        moment(date) {
            return DateFormat(date);
        },
        },
        mounted() {},
    
        beforeDestroy() {},
    
        destroyed() {},
    
        components: {
          // Loading,
          CustomLoader,
          DatePicker,
          ModelListSelect,
          DateRangePicker,
          MaintenanceService,
        },
        created() {
        },
        computed: {
          sortOptions() {
              // Create an options list from our fields
              return this.Columns.filter((f) => f.sortable).map((f) => {
              return { text: f.label, value: f.key };
              });
          },
          
        },
        methods: {
            goToMain() {
                this.$sessionsStorage.set("editResponseId", "");
                this.$router.push({
                    path: "/responseOfQuo/addresponseOfQuo"
                });
            },
            PrintNote(document_rfq) {
              let key = "ASSIGNMENT_UPLOADS/ResponseOfQuotation/" + document_rfq;
              this.openSignedDocument(key);
            },
            PrintValidity_Doc(pridel_doc) {
              let key = "ASSIGNMENT_UPLOADS/" + pridel_doc;
              this.openSignedDocument(key);
            },
            viewAddRQPage(ResID) {
                this.$sessionsStorage.set("editResponseId", ResID);
                this.$router.push({
                    path: "/responseOfQuo/addresponseOfQuo"
                });
            },
            All_Response_Quotation_List_data() {
              this.isLoading = true;
              let payload = {
                  itemCode: "Responese_Data_List",
                  RQ_ID: "",
                  Status: this.Status,
                  dateRange: this.dateRange,
              };
              MaintenanceService.getAllMaintenanceList(payload)
              .then(result => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                  this.stockList = data.itemArray;
                  this.totalRows = data.itemArray.length;
              } else {
                  this.All_Response_Quotation_List_data = [];
              }
              this.isLoading = false;
              })
              .catch(error => {});
            },
            JqueryFun() {
                return $(function () {
                return $("#portLocationNew").DataTable();
                });
            },
            debounceSearch(event) {
                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                this.All_Response_Quotation_List_data();
                }, 1000);
            },
            setFocus: function () {
                // Note, you need to add a ref="search" attribute to your input.
                this.$refs.search.focus();
            },
        },
    };
  </script>
  
  <style>
    .md-direction-bottom-right {
      width: 30% !important;
    }
    .mrgtop-2per {
      margin-top: 1%;
    }
    .mrgtop-5px {
      margin-top: 0px;
    }
    .center {
      text-align: center;
    }
    .heght-1px {
      height: 1px;
    }
    
    .b-form-input-container {
      margin: 4px 0 12px !important;
    }
    .md-button-color {
      background-color: #607d8d !important;
    }
    
    .md-button-color-toggle {
      background-color: rgba(153, 153, 153, 0.4) !important;
    }
    
    .activeClass {
      display: none;
    }
    .error {
      color: red;
    }
  </style>


// WEBPACK FOOTER //
// viewResponse.vue?59c4b74c